import type { Keyword } from '@/types/Keyword';
import { useQuery } from '@tanstack/react-query';

export async function searchSkills(search: string, abortSignal?: AbortSignal) {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_DEVELOPMENT_ENDPOINT}/skills/typeahead/${search}`,
    { signal: abortSignal }
  );
  const data = await response.json();

  data.forEach((item: any) => {
    item.lighthouseId = undefined;
  });

  return data as Keyword[];
}

export default function useSearchSkills(search: string) {
  return useQuery({
    queryKey: ['searchSkills', search],
    queryFn: ({ signal }) => searchSkills(search, signal),
  });
}
